import { render, staticRenderFns } from "./mechanic.vue?vue&type=template&id=5bfca211&scoped=true"
import script from "./mechanic.vue?vue&type=script&lang=js"
export * from "./mechanic.vue?vue&type=script&lang=js"
import style0 from "./mechanic.vue?vue&type=style&index=0&id=5bfca211&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfca211",
  null
  
)

export default component.exports